import logo from './logo.png';

export const settings = {
    "title": "Vanosi CRM",
    "apiUrl": "https://api.crm.vanosiarredamenti.it/api",
    "ckdPath": "https://api.crm.vanosiarredamenti.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    //"googleMapKey": "AIzaSyB0JItfx2zvDnKkmxIBt_wru36tOVcx1iM",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Vanosi Arredamenti S.r.l.',
        "address": 'Vicolo Corridoni 6, 20025 - Legnano (MI), IT',
        "phone": 'Tel: +39 0331 547359',
        "fax": '',
        "email": 'Email: info@vanosiarredamenti.it',
        "iva": 'P.IVA: IT08747010968',
        "cf": '',
        "website": '',
    },
    "dati_pagamento": {
        "iban": "IT29F0503420211000000103752",
        "banca": "Banco BPM Spa",
        "intestatario": "Vanosi Arredamenti S.r.l.",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": false

}